import { render } from "./WinWinFooter.vue?vue&type=template&id=46d7b144&scoped=true"
import script from "./WinWinFooter.vue?vue&type=script&lang=js"
export * from "./WinWinFooter.vue?vue&type=script&lang=js"

import "./WinWinFooter.vue?vue&type=style&index=0&id=46d7b144&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d7b144"]])

export default __exports__